// Central site data for D. Welch Urethane Roofing LTD

export const COMPANY = {
  name: "D. Welch Urethane Roofing LTD",
  shortName: "D. Welch Urethane Roofing",
  phone: "+1 (306) 307-9600",
  phoneRaw: "+13063079600",
  email: "urethanefoam@gmail.com",
  address: "116-2723 Faithful Avenue, Saskatoon, SK S7K 7C3",
  city: "Saskatoon, Saskatchewan",
  tagline: "Industrial-grade roofing. Built for the prairies.",
  since: "Est. Saskatoon",
};

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "Services", href: "#services" },
  { label: "Categories", href: "#categories" },
  { label: "About", href: "#about" },
  { label: "Portfolio", href: "#portfolio" },
  { label: "Contact", href: "#contact" },
];

// Hero banner slides — 5 total
export const SLIDES = [
  {
    kicker: "01 — Commercial",
    title: "COMMERCIAL ROOFING",
    subtitle: "Professional Solutions",
    copy: "Seamless urethane systems engineered for warehouses, offices, and retail complexes across Saskatchewan.",
    image: "/images/commercial.jpg",
  },
  {
    kicker: "02 — Residential",
    title: "RESIDENTIAL ROOFING",
    subtitle: "Expert Protection",
    copy: "Weather-tight, energy-efficient roofing that protects what matters most — your home and family.",
    image: "/images/residential.jpg",
  },
  {
    kicker: "03 — Industrial",
    title: "INDUSTRIAL ROOFING",
    subtitle: "Heavy-Duty Solutions",
    copy: "Tank coatings, plant roofs, and high-traffic industrial applications with military-grade durability.",
    image: "/images/industrial.jpg",
  },
  {
    kicker: "04 — Quality",
    title: "PREMIUM QUALITY",
    subtitle: "Industry-Leading Technology",
    copy: "Sprayed polyurethane foam (SPF) and elastomeric coatings from the top manufacturers in North America.",
    image: "/images/portfolio-15.jpg",
  },
  {
    kicker: "05 — Trust",
    title: "TRUSTED EXPERTS",
    subtitle: "Certified Installation",
    copy: "Licensed, insured, WCB-covered. Decades of prairie roofing experience backing every job.",
    image: "/images/portfolio-13.jpg",
  },
];

// Services — 6 items
export const SERVICES = [
  {
    number: "01",
    title: "Urethane Foam Roofing",
    icon: "Drop",
    copy: "Monolithic, seamless SPF roofing systems that insulate and waterproof in one spray-applied application.",
    features: ["Seamless · zero seams", "R-6.5 per inch", "20+ year lifespan"],
  },
  {
    number: "02",
    title: "Waterproof Coatings",
    icon: "ShieldCheck",
    copy: "High-solids elastomeric topcoats that reflect UV, resist ponding water, and extend roof life by decades.",
    features: ["UV reflective", "Ponding-water rated", "Silicone & acrylic"],
  },
  {
    number: "03",
    title: "Foam Insulation",
    icon: "Thermometer",
    copy: "Closed-cell polyurethane insulation for walls, crawl spaces, and rim joists. Stops air leaks cold.",
    features: ["Closed-cell 2-lb", "Air & vapor barrier", "Energy-bill savings"],
  },
  {
    number: "04",
    title: "Commercial Roofing",
    icon: "Buildings",
    copy: "Flat and low-slope solutions for retail, offices, schools, and multi-unit commercial properties.",
    features: ["Minimal downtime", "Written warranties", "Turnkey project mgmt"],
  },
  {
    number: "05",
    title: "Residential Roofing",
    icon: "House",
    copy: "Homes, cabins, garages, and additions — with warranties and workmanship homeowners can trust.",
    features: ["Free assessments", "Fair, clear pricing", "Clean job sites"],
  },
  {
    number: "06",
    title: "Industrial Roofing",
    icon: "Factory",
    copy: "Chemical plants, grain facilities, tank farms — demanding environments, engineered coatings.",
    features: ["Chemical resistant", "Tank & silo coatings", "WCB-covered crews"],
  },
];

// Categories — 3 columns
export const CATEGORIES = [
  {
    title: "Commercial",
    tag: "Business · Retail · Offices",
    copy: "Scalable roofing programs designed for occupied buildings with tight schedules and budgets.",
    image: "/images/commercial.jpg",
  },
  {
    title: "Residential",
    tag: "Homes · Cabins · Additions",
    copy: "Personalized service and premium materials for every homeowner across Saskatoon and area.",
    image: "/images/residential.jpg",
  },
  {
    title: "Industrial",
    tag: "Plants · Tanks · Facilities",
    copy: "Heavy-duty coatings and insulation that perform where temperature and chemicals are extreme.",
    image: "/images/industrial.jpg",
  },
];

// About features
export const ABOUT_FEATURES = [
  "Licensed, insured, and WCB-covered crews",
  "Decades of Saskatchewan prairie experience",
  "Premium SPF and elastomeric coating systems",
  "Transparent pricing and written warranties",
  "In-house estimators, project managers & crews",
  "Energy-efficient solutions that pay for themselves",
];

// Portfolio — 12 images
export const PORTFOLIO = [
  "/images/portfolio-1.jpg",
  "/images/portfolio-2.jpg",
  "/images/portfolio-3.jpg",
  "/images/portfolio-4.jpg",
  "/images/portfolio-5.jpg",
  "/images/portfolio-6.jpg",
  "/images/portfolio-7.jpg",
  "/images/portfolio-8.jpg",
  "/images/portfolio-9.jpg",
  "/images/portfolio-10.jpg",
  "/images/portfolio-11.jpg",
  "/images/portfolio-12.jpg",
];

export const STATS = [
  { value: "25+", label: "Years of Experience" },
  { value: "500+", label: "Projects Completed" },
  { value: "100%", label: "Licensed & Insured" },
  { value: "24/7", label: "Emergency Response" },
];
